export default [
  {
    key: 'welcome_message',
    value: '',
    label: 'welcomeMessage',
    rules: { required: true, max: 1000 },
    name: 'welcomeMessage',
    as: 'area',
  },
  {
    key: 'privacy_policy_URL',
    value: '',
    label: 'privacyPolicyURL',
    rules: { required: true, max: 2000 },
    name: 'privacyPolicyURL',
    as: 'input',
  },
  {
    key: 'exit_message',
    value: '',
    label: 'exitMessage',
    rules: { required: true, max: 1000 },
    name: 'exitMessage',
    as: 'area',
  },
]
